module.exports = __webpack_public_path__ + "static/media/YouTube.d9d833a0.svg";